import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import Navbar from '../Navbar';
import { IoSearch } from "react-icons/io5";
import { FaArrowRightLong } from "react-icons/fa6";
import { LuMoveRight } from "react-icons/lu";
import { MdAddToPhotos } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { FaChevronRight } from "react-icons/fa6";
import Cookies from 'js-cookie';
import { FaStaylinked } from "react-icons/fa";
import Menu_Items from '../Menu_Items';

function Linkedconditions() {
    const { id, int_id, Ex_id } = useParams();

    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [monitor, setmonitor] = useState(false)
    const [alltables, setalltables] = useState([]);
    const [linkdivs, setlinkdivs] = useState(['div']);
    const [conditionsfields, setconditionsfields] = useState([]);
    const [linkedfields, setlinkedfields] = useState([]);
    const [conditiontablenames, setconditiontablenames] = useState([]);
    const [linkedtablecondition, setlinkedtablecondition] = useState([]);
    const [search_Tables, setsearch_Tables] = useState('');

    let linked_tablename = [];

    const menus = [
        {
            name: 'Integrations',
            id,
        },
        {
            name: 'Out Bound',
            id,
            submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
            { name: 'Conditions', id, int_id, Ex_id },
            { name: 'Linked Tables', id, int_id, Ex_id },
            { name: 'Config', id, int_id, Ex_id },
            { name: 'Result', id, int_id, Ex_id },
            ]
        },
        (su_admin || admin ? { name: 'Users', id } : { name: null, id })
    ];
    // First Run
    const gettables = async () => {
        await axios.get(`/integ/tables/${int_id}`).then((res) => {
            let values = res.data;
            if (values === 'tables Not Fetched') {
                toast.error("Tables Not Fetched", {
                    autoClose: 2000, // 2 seconds
                });
            }
            else {
                setalltables(values);
            }
        })
            .catch((err) => {
                console.log("err :", err);
            });
        await axios.get(`/out_bound/export_value/${Ex_id}`).then((res) => {
            let response = res.data;
            if (response['Linked_Tables']) {
                if (response['Linked_Tables'] !== '') {
                    let linkedtabledetail = JSON.parse(response['Linked_Tables']);
                    setlinkedtablecondition(linkedtabledetail);
                    let linkdiv = [];
                    if (linkedtabledetail.length !== 0) {
                        linkedtabledetail.forEach(async (item, i) => {
                            linked_tablename.push(item.mt);
                            let field = await getfields(item.lt);
                            setfields(field, i);
                            linkdiv.push('div');
                        })
                    }
                    else {
                        linkdiv.push('div');
                    };
                    setlinkdivs(linkdiv);
                    if (response['Headers'] !== '') {
                        const Headers = JSON.parse(response['Headers']);
                        const data = Headers.map((obj) => Object.keys(obj)).flat()
                        linked_tablename = [...new Set(data)];
                        setconditiontablenames(linked_tablename);
                        data.forEach((name) => {
                            handleconditiontable(name);
                        })
                    }

                }
            } else {
                if (response['Headers'] !== '') {
                    const Headers = JSON.parse(response['Headers']);
                    const data = Headers.map((obj) => Object.keys(obj)).flat()
                    linked_tablename = [...new Set(data)];
                    setconditiontablenames(linked_tablename);
                    data.forEach((name) => {
                        handleconditiontable(name);
                    })
                }
            }

        })
            .catch((err) => {
                toast.error("Error", {
                    autoClose: 2000, // 2 seconds
                });
            })
    };
    // searcher by Tables
    const filterbyTables = alltables.filter(name =>
        name.toLowerCase().startsWith(search_Tables.toLowerCase())
    );
    // calls Required
    const handleconditiontable = async (name) => {
        if (conditiontablenames.includes(name)) {
            setconditionsfields(prevData => prevData.filter(item => !item.hasOwnProperty(name)));
            setconditiontablenames(conditiontablenames.filter(item => item !== name));
            setlinkedtablecondition(prevData => prevData.filter(obj => obj.mt !== name));
        }
        else {
            setconditiontablenames(prevState => [...prevState, name]);
            await axios.get(`/integ/field/${name}/${int_id}`).then((res) => {
                let values = res.data;
                setconditionsfields(prevState => [...prevState, { [name]: values }]);
            })
                .catch((err) => {
                    console.log("Error from conditiontables.js ");
                });
        };
    };
    const addDiv = () => {
        setlinkdivs([...linkdivs, 'div'])
    };
    const handlelinkconditionfield = (e, i) => {
        const value = e.target.value;
        const [item, tname] = value.split(' --- ');
        let t = tname;
        let v = item;
        if (linkedtablecondition.length === 0) {
            setlinkedtablecondition([{ 'mt': t, 'mtf': v }]);
        }
        else {
            let existingIndex = linkedtablecondition.findIndex((obj, index) => index === i);
            if (existingIndex === -1) {
                setlinkedtablecondition([...linkedtablecondition, { 'mt': t, 'mtf': v }]);
            }
            else {
                setlinkedtablecondition(prevData =>
                    prevData.map((item, index) =>
                        index === i ? { ...item, 'mt': t, 'mtf': v } : item
                    ))
            }
        }

    };
    const getfields = async (value) => {
        let val;
        await axios.get(`/integ/field/${value}/${int_id}`).then((res) => {
            const values = res.data;
            let newobj = values;
            val = newobj;

        })
            .catch((err) => {
                toast.error("Fields Error", {
                    autoClose: 2000, // 2 seconds
                });

            })
        return val;
    };
    const setfields = (value, i) => {
        let existingIndex = linkedfields.findIndex((obj, index) => index === i);
        if (existingIndex === -1) {
            setlinkedfields([...linkedfields, { 'index': i, 'fields': value }]);
        }
        else {
            setlinkedfields((prevData) =>
                prevData.map((obj, index) =>
                    index === i ? { 'index': i, 'fields': value } : obj
                )
            )
        };

    };
    const handlelinktable = async (value, i) => {
        let fieldvalue = await getfields(value);
        setfields(fieldvalue, i);
        if (linkedtablecondition.length === 0) {
            setlinkedtablecondition([{ 'lt': value }]);
        }
        else {
            let existingIndex = linkedtablecondition.findIndex((obj, index) => index === i);
            if (existingIndex === -1) {
                setlinkedtablecondition([...linkedtablecondition, { 'lt': value }]);
            }
            else {
                setlinkedtablecondition(prevData =>
                    prevData.map((item, index) =>
                        index === i ? { ...item, 'lt': value } : item
                    ))
            }
        };

    };
    const handlelinkedfield = (fn, e, i) => {
        const value = e.target.value;
        setlinkedtablecondition(prevData =>
            prevData.map((item, index) =>
                index === i ? { ...item, [fn]: value } : item
            ));
    };
    const closediv = (i) => {
        if (linkdivs.length === 1) {
            setlinkedtablecondition(prevData => prevData.filter((val, index) => index !== i));
        }
        else {
            setlinkedtablecondition(prevData => prevData.filter((val, index) => index !== i));
            setlinkdivs(prevData => prevData.slice(0, -1));
        }
    };
    const conditionsubmit = async () => {
        let value = JSON.stringify(linkedtablecondition);
        let linked_table_condition = {
            Linked_Tables: value
        };
        await axios.patch(`/out_bound/linkedtables/${Ex_id}`, linked_table_condition).then((res) => {
            toast.success("Linked Table Conditions Updated", {
                autoClose: 2000, // 2 seconds
            });
        })
            .catch((err) => {
                toast.error("Linkedcondition conditionsubmit api error", {
                    autoClose: 2000, // 2 seconds
                });
            });
    };
    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }
        else {
            setmonitor(true)
        }

    };
    const Check = () => {
        console.log(123, conditiontablenames);

    }
    useEffect(() => {
        gettables();
        get_level();
    }, []);
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <FaStaylinked className='page_icon db' onClick={Check} />
                            <p>Linked Tables</p>
                        </div>
                    </div>
                    <div className='box df jc ac'>
                        {/* <div className='h83 w15'>
                            <div className='condition_table_box_head df jc ac'>
                                <p>Tables</p>
                            </div>
                            <div className='condition_table_box_content_tablessearch df jc ac b0100'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' onChange={e => setsearch_Tables(e.target.value)} />
                            </div>
                            <div className='condition_table_box_content b0100'>
                                {
                                    filterbyTables.length > 0 && filterbyTables.map((val, index) => {
                                        if (val !== undefined) {
                                            if (val !== '') {
                                                let table = val.charAt(0).toUpperCase() + val.slice(1);
                                                return (
                                                    <div className=' condition_table_box_content_con df gap ac m1' key={index}>
                                                        <input type='checkbox' onClick={() => { handleconditiontable(val) }} id={index} checked={conditiontablenames.includes(val)} disabled={monitor} />
                                                        <label htmlFor={index} >{table}</label>
                                                    </div>
                                                )
                                            }
                                        }
                                    })
                                }
                            </div>
                        </div> */}
                        <div className='h83 w100'>
                            {/* <div className='condition_table_box2_head df jc ac'>
                                <p className='p'>Link to Tables</p>
                            </div> */}
                            <div className='condition_table_box2_Content df fdc ac'>
                                <div className='condition_model_add df jb ac'>
                                    <div></div>
                                    <div></div>
                                    <div className='addicondiv df je ac'>
                                        {!monitor &&
                                            <MdAddToPhotos onClick={() => { addDiv('and'); }} className='icon3 g' />
                                        }
                                    </div>
                                </div>
                                {
                                    linkdivs.map((_, index) => {
                                        return (
                                            <div className='h10 w95 df js ac' key={`d${index}`}>
                                                <div className='h7 w15 df fdc jc' key={`f${index}`}>
                                                    <label>Select Fields - Table</label>
                                                    <select onChange={(e) => { handlelinkconditionfield(e, index) }} disabled={monitor} className='h4'>

                                                        {
                                                            linkedtablecondition.length > 0 && linkedtablecondition.map((item, i) => {
                                                                if (item.mt !== undefined) {
                                                                    if (item.mtf !== undefined) {
                                                                        let tname = item.mt.charAt(0).toUpperCase() + item.mt.slice(1);
                                                                        let field = item.mtf.charAt(0).toUpperCase() + item.mtf.slice(1);
                                                                        if (i === index) {
                                                                            return (
                                                                                <option value={`${item.mtf} --- ${item.mt}`} selected key={`${item.mtf}${item.mt}`}>{field} - {tname}</option>
                                                                            )
                                                                        }
                                                                    }

                                                                }


                                                            })
                                                        }
                                                        <option>Please Select</option>
                                                        {
                                                            conditionsfields.length > 0 && conditionsfields.map((item) => {
                                                                let tna = Object.keys(item);
                                                                let fie = Object.values(item);
                                                                let fiel = fie[0];
                                                                let tnam = tna[0];
                                                                if (tnam !== undefined) {
                                                                    let tname = tnam.charAt(0).toUpperCase() + tnam.slice(1);
                                                                    if (fiel.length > 0) {
                                                                        return fiel.map((fi) => {
                                                                            if (fi !== undefined) {
                                                                                let field = fi.charAt(0).toUpperCase() + fi.slice(1);
                                                                                return (
                                                                                    <option value={`${fi} --- ${tnam}`} key={`${fi}${tnam}`}>{field} - {tname}</option>
                                                                                )
                                                                            }
                                                                        })
                                                                    }
                                                                }
                                                            })
                                                        }

                                                    </select>
                                                </div>
                                                <div className='h4 w10 df je ae'>
                                                    <div className='h1 w50 b1000'></div>
                                                    <div className='h2 w30 df ac'><FaChevronRight className='b' /></div>
                                                </div>
                                                <div className='h7 w15 df fdc jc'>
                                                    <label>Link To Table</label>
                                                    <select onChange={(e) => { handlelinktable(e.target.value, index) }} disabled={monitor} className='h4'>

                                                        {
                                                            linkedtablecondition.length > 0 && linkedtablecondition.map((item, i) => {
                                                                if (item.lt !== undefined) {
                                                                    let tname = item.lt.charAt(0).toUpperCase() + item.lt.slice(1);
                                                                    if (i === index) {
                                                                        return (
                                                                            <option value={item.lt} selected key={item.lt}>{tname}</option>
                                                                        )
                                                                    }
                                                                }


                                                            })
                                                        }
                                                        <option>Please Select</option>
                                                        {
                                                            alltables.length > 0 && alltables.map((val) => {
                                                                if (val !== undefined) {
                                                                    let table = val.charAt(0).toUpperCase() + val.slice(1);
                                                                    return (
                                                                        <option value={val} key={val}>{table}</option>
                                                                    )
                                                                }

                                                            })
                                                        }

                                                    </select>
                                                </div>
                                                <div className='h4 w10 df je ae'>
                                                    <div className='h1 w50 b1000'></div>
                                                    <div className='h2 w30 df ac'><FaChevronRight className='b' /></div>
                                                </div>
                                                <div className='h7 w15 df fdc jc'>
                                                    <label>Matched Field</label>
                                                    <select onChange={(e) => { handlelinkedfield('ltf', e, index) }} disabled={monitor} className='h4'>

                                                        {
                                                            linkedtablecondition.length > 0 && linkedtablecondition.map((item, i) => {
                                                                if (item.ltf !== undefined) {
                                                                    let lfield = item.ltf.charAt(0).toUpperCase() + item.ltf.slice(1);
                                                                    if (i === index) {
                                                                        return (
                                                                            <option value={item.ltf} selected key={item.ltf}>{lfield}</option>
                                                                        )
                                                                    }
                                                                }


                                                            })
                                                        }
                                                        <option>Please Select</option>
                                                        {
                                                            linkedfields
                                                                .filter((val) => val.index === index) // Only process relevant items
                                                                .flatMap((val) =>
                                                                    val.fields
                                                                        .filter((f) => f) // Remove undefined fields
                                                                        .map((f, idx) => (
                                                                            <option key={f} value={f}>
                                                                                {f.charAt(0).toUpperCase() + f.slice(1)}
                                                                            </option>
                                                                        ))
                                                                )
                                                        }


                                                    </select>
                                                </div>
                                                <div className='h4 w10 df je ae'>
                                                    <div className='h1 w50 b1000'></div>
                                                    <div className='h2 w30 df ac'><FaChevronRight className='b' /></div>
                                                </div>
                                                <div className='h7 w15 df fdc jc'>
                                                    <label>Value Field</label>
                                                    <select onChange={(e) => { handlelinkedfield('vf', e, index) }} disabled={monitor} className='h4'>

                                                        {
                                                            linkedtablecondition.length > 0 && linkedtablecondition.map((item, i) => {
                                                                if (item.vf !== undefined) {
                                                                    if (item.vf !== '') {
                                                                        let tname = item.vf.charAt(0).toUpperCase() + item.vf.slice(1);
                                                                        if (i === index) {
                                                                            return (
                                                                                <option value={item.vf} selected key={item.vf}>{tname}</option>
                                                                            )
                                                                        }
                                                                    }
                                                                }
                                                            })
                                                        }
                                                        <option>Please Select</option>
                                                        {
                                                            linkedfields.length > 0 && linkedfields.map((val) => {
                                                                if (val['index'] === index) {
                                                                    return val['fields'].map((f) => {
                                                                        if (f !== undefined) {
                                                                            if (f !== '') {
                                                                                let field = f.charAt(0).toUpperCase() + f.slice(1);
                                                                                return (
                                                                                    <option value={f} key={f}>{field}</option>
                                                                                )
                                                                            }
                                                                        }
                                                                    })
                                                                }

                                                            })
                                                        }

                                                    </select>
                                                </div>
                                                <div className='h3 w3 df jc ae'>
                                                    <IoClose className='r' onClick={() => { closediv(index) }} />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='condition_table_box2_action df jc ac'>
                                {!monitor && <button className='btn green' onClick={conditionsubmit}>Submit</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='h_btn df jc ae'>
                <p className='df jc ac'>Linked Tables</p>
                <div className='menu_bar h5 w25 df je ac gap1'>
                    <Link to={home_path} className='menu_icon df jc ac' ><AiFillHome className='icon2' /></Link>
                    <Link to={`/out_bound/conditions/${id}/${int_id}/${Ex_id}`} className='menu_icon df jc ac' ><IoChevronBackCircleSharp className='icon2' /></Link>
                    {
                        (admin_level) &&
                        <>
                            <Link to={`/company/users/${id}`} className='menu_icon df jc ac'><FaUsers className='icon2' /></Link>
                            <Link to={`/integ/${id}`} className='menu_icon df jc ac'><SiGitconnected className='icon2' /></Link>
                        </>
                    }
                    {
                        (admin_level || user_level) &&
                        <>
                            <Link to={`/out_bound_details/${id}/${int_id}`} className='menu_icon df jc ac' ><RiExportFill className='icon2' /></Link>                        </>


                    }
                    <Link to={"/"} className='menu_icon df jc ac' ><MdLogout className='icon2' /></Link>
                </div>
            </div> */}
            {/* <div className='t_box df jc ac'>
            </div> */}
            {/* <Back location={`/out_bound/conditions/${id}/${int_id}/${Ex_id}`} /> */}
        </div >
    )
}

export default Linkedconditions;